var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkLp3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2 28.1L16.9 23.8C16.5333 23.4333 16.0667 23.25 15.5 23.25C14.9333 23.25 14.4667 23.4333 14.1 23.8C13.7333 24.1667 13.55 24.6333 13.55 25.2C13.55 25.7667 13.7333 26.2333 14.1 26.6L19.8 32.3C20.2 32.7 20.6667 32.9 21.2 32.9C21.7333 32.9 22.2 32.7 22.6 32.3L33.9 21C34.2667 20.6333 34.45 20.1667 34.45 19.6C34.45 19.0333 34.2667 18.5667 33.9 18.2C33.5333 17.8333 33.0667 17.65 32.5 17.65C31.9333 17.65 31.4667 17.8333 31.1 18.2L21.2 28.1ZM24 44.5C21.2333 44.5 18.6333 43.975 16.2 42.925C13.7667 41.875 11.65 40.45 9.85 38.65C8.05 36.85 6.625 34.7333 5.575 32.3C4.525 29.8667 4 27.2667 4 24.5C4 21.7333 4.525 19.1333 5.575 16.7C6.625 14.2667 8.05 12.15 9.85 10.35C11.65 8.55 13.7667 7.125 16.2 6.075C18.6333 5.025 21.2333 4.5 24 4.5C26.7667 4.5 29.3667 5.025 31.8 6.075C34.2333 7.125 36.35 8.55 38.15 10.35C39.95 12.15 41.375 14.2667 42.425 16.7C43.475 19.1333 44 21.7333 44 24.5C44 27.2667 43.475 29.8667 42.425 32.3C41.375 34.7333 39.95 36.85 38.15 38.65C36.35 40.45 34.2333 41.875 31.8 42.925C29.3667 43.975 26.7667 44.5 24 44.5Z",
    fill: "#2A71FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkLp3);
export default __webpack_public_path__ + "static/media/checkmark-lp3.579ab9f410dfe165fbbf646723e26e32.svg";
export { ForwardRef as ReactComponent };